
import { 
  BonusSection, 
  NewBonusSection, 
  ExpertInsight,
  UnexpectedAnalogy,
  ChallengedAssumption,
  InsiderTip,
  LegacyBonusItem
} from '@/types/analysisTypes';

/**
 * Check if the bonus section uses the new format
 */
export function isNewBonusFormat(bonusSection: BonusSection): bonusSection is NewBonusSection {
  if (!bonusSection) return false;
  
  // Check if it has at least one of the new format properties with the expected structure
  return (
    isNewFormatExpertInsight(bonusSection.expert_insight) ||
    isNewFormatUnexpectedAnalogy(bonusSection.unexpected_analogy) ||
    isNewFormatChallengedAssumption(bonusSection.challenged_assumption) ||
    isNewFormatInsiderTip(bonusSection.insider_tip)
  );
}

/**
 * Check if expert_insight is in the new format
 */
export function isNewFormatExpertInsight(item: any): item is ExpertInsight {
  return (
    item && 
    typeof item === 'object' &&
    (item.title !== undefined || 
     item.intro !== undefined || 
     item.key_takeaways !== undefined || 
     item.conclusion !== undefined)
  );
}

/**
 * Check if unexpected_analogy is in the new format
 */
export function isNewFormatUnexpectedAnalogy(item: any): item is UnexpectedAnalogy {
  return (
    item && 
    typeof item === 'object' &&
    (item.title !== undefined || 
     item.intro !== undefined || 
     item.key_points !== undefined || 
     item.conclusion !== undefined)
  );
}

/**
 * Check if challenged_assumption is in the new format
 */
export function isNewFormatChallengedAssumption(item: any): item is ChallengedAssumption {
  return (
    item && 
    typeof item === 'object' &&
    (item.title !== undefined || 
     item.intro !== undefined || 
     item.key_reasons !== undefined || 
     item.solution !== undefined)
  );
}

/**
 * Check if insider_tip is in the new format
 */
export function isNewFormatInsiderTip(item: any): item is InsiderTip {
  return (
    item && 
    typeof item === 'object' &&
    (item.title !== undefined || 
     item.intro !== undefined || 
     item.step_by_step !== undefined || 
     item.final_takeaway !== undefined)
  );
}

/**
 * Check if an item is a legacy bonus item
 */
export function isLegacyBonusItem(item: any): item is LegacyBonusItem {
  return (
    item && 
    typeof item === 'object' &&
    (item.question !== undefined || item.example !== undefined)
  );
}
